// Columns render the denormalized stored count fields (matchCount,
// matchSeatRatio, interestedCount, appliedCount) rather than live-computed
// values from populated candidacies. This keeps the displayed number identical
// to the field the server sorts by, so column sorting is correct across every
// paginated page. Stored counts are maintained by candidacy/job lifecycles.
export const jobStatColumns = ({ sortable = false } = {}) => [
    {
        header: 'Matches',
        property: 'matchCount',
        sortable,
        render: (job) => job.matchCount ?? 0,
    },
    {
        header: 'Seats',
        property: 'seats',
        sortable,
    },
    {
        header: 'Match/Seat Ratio',
        property: 'matchSeatRatio',
        sortable,
        render: (job) => job.matchSeatRatio ?? 0,
    },
    {
        header: 'Interested',
        property: 'interestedCount',
        sortable,
        render: (job) => job.interestedCount ?? 0,
    },
    {
        header: 'Applied',
        property: 'appliedCount',
        sortable,
        render: (job) => job.appliedCount ?? 0,
    },
];
